import React from 'react';

export const TickIcon = () => (
  <svg
    viewBox='0 0 16 16'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <path d='M3 8.5l3.2 3.2L13 5' />
  </svg>
);

export const MinusCircleIcon = () => (
  <svg viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='1.5' />
    <path
      d='M8 12h8'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);

export const LockIcon = () => (
  <svg
    viewBox='0 0 16 16'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.8'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <rect x='3.5' y='7' width='9' height='6.5' rx='1.5' />
    <path d='M5.5 7V4.8a2.5 2.5 0 015 0V7' />
  </svg>
);

export const InfoCircleIcon = () => (
  <svg
    viewBox='0 0 16 16'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.6'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <circle cx='8' cy='8' r='6.25' />
    <path d='M8 5v3.5M8 11h.01' />
  </svg>
);

export const HintCircleIcon = () => (
  <svg
    viewBox='0 0 16 16'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <circle cx='8' cy='8' r='6.25' />
    <path d='M8 10.7V8M8 5.6h.01' />
  </svg>
);

export const WarnTriangleIcon = () => (
  <svg
    viewBox='0 0 16 16'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.6'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <path d='M8 2.2l6 11.6H2z' />
    <path d='M8 6.6v3.1M8 11.8h.01' />
  </svg>
);

export const ExternalArrowIcon = () => (
  <svg
    viewBox='0 0 16 16'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.5'
    aria-hidden='true'
  >
    <path
      d='M5 11L11 5M11 5H6M11 5v5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

/** Figma lock-01 (32px outline). */
export const LockOutlineIcon = () => (
  <svg
    viewBox='0 0 32 32'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <path d='M22.6667 13.3333V10.6667C22.6667 6.98477 19.6819 4 16 4C12.3181 4 9.33333 6.98477 9.33333 10.6667V13.3333M16 19.3333V22M11.7333 28H20.2667C22.5069 28 23.627 28 24.4826 27.564C25.2353 27.1805 25.8472 26.5686 26.2307 25.816C26.6667 24.9603 26.6667 23.8402 26.6667 21.6V19.7333C26.6667 17.4931 26.6667 16.373 26.2307 15.5174C25.8472 14.7647 25.2353 14.1528 24.4826 13.7693C23.627 13.3333 22.5069 13.3333 20.2667 13.3333H11.7333C9.49312 13.3333 8.37302 13.3333 7.51737 13.7693C6.76472 14.1528 6.1528 14.7647 5.76931 15.5174C5.33333 16.373 5.33333 17.4931 5.33333 19.7333V21.6C5.33333 23.8402 5.33333 24.9603 5.76931 25.816C6.1528 26.5686 6.76472 27.1805 7.51737 27.564C8.37302 28 9.49312 28 11.7333 28Z' />
  </svg>
);

/** Figma x-close (20px). */
export const CloseIcon = () => (
  <svg
    viewBox='0 0 20 20'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <path d='M15 5L5 15M5 5L15 15' />
  </svg>
);

export const WhatsAppIcon = () => (
  <svg viewBox='0 0 24 24' fill='currentColor' aria-hidden='true'>
    <path d='M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38a9.9 9.9 0 004.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm0 18.15c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.22 8.22 0 01-1.26-4.38c0-4.54 3.7-8.23 8.25-8.23 2.2 0 4.27.86 5.83 2.42a8.19 8.19 0 012.41 5.82c0 4.54-3.7 8.23-8.24 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.79.97-.14.16-.29.18-.54.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.43.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.48c-.16 0-.43.06-.65.31-.22.25-.85.84-.85 2.05s.87 2.38.99 2.54c.12.17 1.71 2.61 4.15 3.66.58.25 1.03.4 1.39.51.58.19 1.11.16 1.53.1.47-.07 1.47-.6 1.677-1.18.2-.58.2-1.08.14-1.18-.06-.11-.22-.17-.47-.29z' />
  </svg>
);

export const MondayLogo = () => (
  <svg className='logo' viewBox='0 0 256 256' fill='none' aria-hidden='true'>
    <g transform='translate(0 50)'>
      <path
        fill='#F62B54'
        d='M31.846 153.489a31.97 31.97 0 0 1-27.86-16.167a30.91 30.91 0 0 1 .875-31.823l57.373-90.096A31.99 31.99 0 0 1 90.556.015a31.93 31.93 0 0 1 27.41 16.896c5.349 10.113 4.68 22.28-1.725 31.774L58.904 138.78a31.98 31.98 0 0 1-27.058 14.709'
      />
      <path
        fill='#FFCC00'
        d='M130.256 153.488c-11.572 0-22.22-6.187-27.812-16.13a30.81 30.81 0 0 1 .875-31.737l57.264-89.89A31.94 31.94 0 0 1 188.93.016c11.669.255 22.244 6.782 27.592 16.993a30.81 30.81 0 0 1-2.066 31.92l-57.252 89.889a31.93 31.93 0 0 1-26.948 14.671'
      />
      <ellipse
        cx='226.466'
        cy='125.324'
        fill='#00CA72'
        rx='29.538'
        ry='28.918'
      />
    </g>
  </svg>
);

export const AsanaLogo = () => (
  <svg className='logo' viewBox='0 0 16 16' fill='none' aria-hidden='true'>
    <path
      fill='#F06A6A'
      d='M8 2.1c-1.7397 0 -3.15 1.4103 -3.15 3.15S6.2603 8.4 8 8.4s3.15 -1.4103 3.15 -3.15S9.7397 2.1 8 2.1Z'
    />
    <path
      fill='#F06A6A'
      d='M4.05 9.1c-1.7397 0 -3.15 1.4103 -3.15 3.15 0 1.7397 1.4103 3.15 3.15 3.15s3.15 -1.4103 3.15 -3.15c0 -1.7397 -1.4103 -3.15 -3.15 -3.15Z'
    />
    <path
      fill='#F06A6A'
      d='M11.95 9.1c-1.7397 0 -3.15 1.4103 -3.15 3.15 0 1.7397 1.4103 3.15 3.15 3.15 1.7397 0 3.15 -1.4103 3.15 -3.15 0 -1.7397 -1.4103 -3.15 -3.15 -3.15Z'
    />
  </svg>
);

export const LushaLogo = () => (
  <svg
    className='logo'
    viewBox='-1 2.25 27.5 27.5'
    fill='none'
    aria-hidden='true'
  >
    <path
      fill='#600DFF'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.6336 9.31097C20.6336 9.80679 20.5685 10.2586 20.448 10.6688C25.5512 13.6678 22.9243 23.425 22.1553 25.9104C22.1341 25.979 22.0162 25.9526 22.0184 25.8809C22.0434 25.0557 21.915 23.8983 21.3489 22.7842C21.3659 22.9307 21.3746 23.0797 21.3746 23.2308C21.3746 25.352 19.6557 27.0715 17.5353 27.0715C15.4149 27.0715 13.696 25.352 13.696 23.2308C13.696 22.8372 13.7551 22.4575 13.8651 22.1C13.8344 22.0919 13.8021 22.0837 13.7685 22.0754C13.5461 22.0208 13.3125 21.9778 13.1568 21.9778C13.0018 21.9778 12.7775 22.0198 12.566 22.0731C12.5271 22.0829 12.49 22.0927 12.4555 22.1022C12.5651 22.4592 12.624 22.8383 12.624 23.2312C12.624 25.3523 10.9051 27.0719 8.78472 27.0719C6.82415 27.0719 5.20681 25.6018 4.97413 23.7034C4.57854 25.2802 4.56924 26.9897 4.63748 28.9407C4.63962 29.0017 4.56111 29.0284 4.53063 28.9755C2.82232 26.0091 1.24842 19.8656 2.38651 15.3358C3.40492 11.2823 6.25787 9.32881 8.04941 8.65901C8.37557 5.47988 11.0607 3 14.3249 3C17.8091 3 20.6336 5.82552 20.6336 9.31097ZM7.14073 19.7594C7.63907 19.5228 8.19644 19.3904 8.78472 19.3904C10.1608 19.3904 11.3678 20.1147 12.0456 21.2029C12.1184 21.181 12.2173 21.1527 12.3299 21.1243C12.555 21.0676 12.8761 20.9997 13.1568 20.9997C13.4368 20.9997 13.7667 21.0682 13.9988 21.1252C14.1066 21.1517 14.2026 21.178 14.2764 21.1993C14.9546 20.1129 16.1606 19.3901 17.5353 19.3901C17.6851 19.3901 17.8329 19.3987 17.9782 19.4154C16.6567 17.8504 16.1414 15.6657 15.955 14.2919C11.5409 16.2028 8.812 17.9517 7.14073 19.7594ZM20.1899 23.2308C20.1899 24.698 19.001 25.8867 17.5353 25.8867C16.0696 25.8867 14.8807 24.698 14.8807 23.2308C14.8807 21.7636 16.0696 20.5748 17.5353 20.5748C19.001 20.5748 20.1899 21.7636 20.1899 23.2308ZM11.4393 23.2312C11.4393 24.6984 10.2504 25.8871 8.78472 25.8871C7.31904 25.8871 6.13014 24.6984 6.13014 23.2312C6.13014 21.7639 7.31904 20.5752 8.78472 20.5752C10.2504 20.5752 11.4393 21.7639 11.4393 23.2312Z'
    />
  </svg>
);
